module.exports = __webpack_public_path__ + "static/fa-brands-400-ed2b8bf117160466ba6220a8f1da54a4.ttf";